// src/hooks/paxTypes/useCreatePaxType.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createPaxType } from "../../api/apiPaxTypes";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreatePaxType = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createPaxTypes, isPending } = useMutation({
        mutationFn: createPaxType,
        onSuccess: (res) => {
            const message = res?.message || "Pax type created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["paxTypes"] });
            navigate("/pax-types");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create pax type");
        },
    });

    return { createPaxTypes, isPending };
};

export default useCreatePaxType;